// @flow
import * as React from 'react';

import BreadcrumbsList from '@ta/homepage.breadcrumbs';
import MastheadH1 from '@ta/homepage.masthead-h1-over-image';
import classNames from '@ta/common.classnames';
import { featureIsEnabled } from '@ta/common.features';

import styles from './BreadcrumbsAndHeaderOverImage.less';

type Props = {
  breadcrumbs: any,
  headerText: string,

  /**
   * If true, this appears over a solid background rather than an imaage, so we should simplify
   * the style
   */
  flat?: boolean,
};

const BreadcrumbsAndHeaderOverImage = ({ breadcrumbs, headerText, flat }: Props) => (
  <div
    className={classNames(styles.overImageContainer, {
      breadcrumb_menu: featureIsEnabled('breadcrumbs_as_global_nav'),
      [styles.flat]: flat,
    })}
  >
    <div className="ui_container">
      <div className={styles.row}>
        <span className={styles.cell}>
          <BreadcrumbsList breadcrumbs={breadcrumbs} flat={flat} />
        </span>
        <span className={classNames(styles.cell, styles.header)}>
          <MastheadH1 mastheadH1Text={headerText} />
        </span>
      </div>
    </div>
  </div>
);

export default BreadcrumbsAndHeaderOverImage;
